import { useState, useEffect } from "react";
import { api, formatApiError, BACKEND } from "@/lib/api";
import { toast } from "sonner";
import { DEFAULTS, useContent } from "@/lib/content";
import { MEDIA_ASSETS } from "./constants";

export default function MediaManager() {
  const { setContent } = useContent();
  const [vals, setVals] = useState(null);
  const [uploading, setUploading] = useState(null);

  useEffect(() => {
    api.get("/content").then(({ data }) => setVals({ ...DEFAULTS, ...data }));
  }, []);

  const setVal = (k, v) => setVals((p) => ({ ...p, [k]: v }));
  const persist = async (k, v) => {
    try {
      const { data } = await api.put("/admin/content", { updates: { [k]: v } });
      setContent && setContent({ ...DEFAULTS, ...data });
      toast.success("Media updated — live on the site");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Save failed");
    }
  };
  const upload = async (k, e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setUploading(k);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/admin/uploads", fd);
      const url = `${BACKEND}${data.url}`;
      setVal(k, url);
      await persist(k, url);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Upload failed");
    } finally {
      setUploading(null);
      e.target.value = "";
    }
  };

  if (!vals) return <p className="opacity-60 py-12 text-center animate-pulse" data-testid="media-loading">Loading media...</p>;

  return (
    <div data-testid="media-panel" className="space-y-6 max-w-3xl">
      <p className="overline text-[#DFFF00]">Upload or link the imagery shown across the site</p>
      {MEDIA_ASSETS.map((a) => (
        <div key={a.key} data-testid={`media-${a.key}`} className="border-2 border-[#F2EFEB]/40 p-4 flex flex-col sm:flex-row gap-4">
          <div className="w-full sm:w-48 h-32 border-2 border-[#F2EFEB]/40 overflow-hidden shrink-0 bg-[#111]">
            {vals[a.key] && <img src={vals[a.key]} alt="" className="w-full h-full object-cover grayscale" />}
          </div>
          <div className="flex-1 min-w-0">
            <p className="uppercase text-sm mb-2">{a.label}</p>
            <label className={`inline-flex items-center gap-2 h-10 px-4 border-2 border-dashed border-[#DFFF00] text-[#DFFF00] uppercase text-xs tracking-widest cursor-pointer hover:bg-[#DFFF00]/10 transition-colors ${uploading === a.key ? "opacity-60 pointer-events-none" : ""}`}>
              {uploading === a.key ? "Uploading..." : "↑ Upload image"}
              <input type="file" accept="image/jpeg,image/png,image/webp,image/gif" onChange={(e) => upload(a.key, e)} data-testid={`media-upload-${a.key}`} className="hidden" />
            </label>
            <div className="flex gap-2 mt-3">
              <input value={vals[a.key]} onChange={(e) => setVal(a.key, e.target.value)} data-testid={`media-url-${a.key}`} className="flex-1 bg-transparent border-2 border-[#F2EFEB] px-2 h-10 text-xs focus:outline-none focus:border-[#DFFF00]" />
              <button onClick={() => persist(a.key, vals[a.key])} data-testid={`media-save-${a.key}`} className="h-10 px-4 border-2 border-[#F2EFEB] text-xs uppercase hover:bg-[#DFFF00] hover:text-[#090909] transition-colors">Save</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
